export const environment = {
  production: true,
  accountManagementCenter: 'https://account.ama-assn.org/',
  // apiUrl: 'https://usan-api-aws.ama-assn.org/usanapi',
  orgManagerURL: 'https://apps.ama-assn.org/orgManager',
  eProfilesSearchURL: 'https://apps.ama-assn.org/profile/admin/profileSearch',
  eProfilesDNRURL: 'https://apps.ama-assn.org/profile/eprofiles/eprofiles-dnr',
  eProfilesAdminURL: 'https://apps.ama-assn.org/profile/eprofiles/eprofiles-admin',
  jamaURL: 'https://jamanetwork.com/myaccount',
  morningRoundsURL: 'https://apps.ama-assn.org/MorningRound/online/searchForPhysicians/view.do',
  upgradeProfileURL: 'https://apps.ama-assn.org/profile/user/upgradeProfile',
  amaStore: 'https://commerce.ama-assn.org/store/',
  amaWire: 'https://wire.ama-assn.org/',
  jama: 'https://jamanetwork.com/',
  journalOfEthics: 'http://journalofethics.ama-assn.org/',
  amaStoreAccount: 'https://commerce.ama-assn.org/store/admins/account.jsp',
  becomeMember: 'https://ama-assn.org/membership',
  login: 'https://login.ama-assn.org/account/login/',
  logout: 'https://fsso.ama-assn.org/account/logout',
  joinRenew: 'https://member.ama-assn.org/join-renew/',
  usan: 'https://apply-usan.ama-assn.org/',
  orgIdForNegotiators: '33008',
  securityOff: false
};
